"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.D3Charts = void 0;
const d3 = __importStar(require("d3"));
class D3Charts {
    constructor() {
        this.p1supplement = 0.153592; // Punta - 10h-14h, 18h-22h
        this.p2supplement = 0.088550; // Llano - 8h-10h, 14h-18h
        this.p3supplement = 0.063203; // Valle - 0h-8h, weekends 0h-24h
        this.color1 = "#1e607f";
        this.color2 = "#237194"; // Light blue for regulated costs
        this.feastDays = [
            "01-01", "01-06", "04-18", "01-05", //"06-04",
            "15-08", "11-01", "12-06", "12-08", "12-25"
        ];
        console.log("D3 init");
    }
    getSupplement(hour, date) {
        if (date.getDay() === 0 || date.getDay() === 6)
            return this.p3supplement;
        const monthDay = date.toISOString().slice(5, 10);
        if (this.feastDays.includes(monthDay))
            return this.p3supplement;
        if ((hour >= 10 && hour < 14) || (hour >= 18 && hour < 22))
            return this.p1supplement;
        if ((hour >= 8 && hour < 10) || (hour >= 14 && hour < 18))
            return this.p2supplement;
        return this.p3supplement;
    }
    createChart(data, date = new Date()) {
        //Get the language from the document
        const lang = document.documentElement.lang || "es";
        const eurKwhString = lang === 'zh-CN' ? "欧元/千瓦时" : lang === 'ast-ES' ? "EUR/qWh" : "EUR/kWh";
        const tempDiscount = 0.03; // Temporary discount to make the chart more visually appealing.
        const dataKwh = data.map(d => (d / 1000) - tempDiscount);
        let container = d3.select("#mn_precios_omie_chart");
        if (container.empty()) {
            container = d3.select("body")
                .append("div")
                .attr("id", "mn_precios_omie_chart");
        }
        container.html(""); // Clear previous chart
        const containerWidth = container.node()?.getBoundingClientRect().width || 800;
        const isMobile = containerWidth < 764;
        const width = containerWidth;
        const height = isMobile ? 800 : 450;
        // For mobile: more top margin for legend, no left padding
        const margin = isMobile
            ? { top: 70, right: 20, bottom: 40, left: 40 }
            : { top: 20, right: 30, bottom: 50, left: 30 };
        const svg = container.append("svg")
            .attr("width", width)
            .attr("height", height);
        // Generate labels for 15-minute intervals (96 total)
        const timeLabels = dataKwh.map((_, i) => {
            const hour = Math.floor(i / 4);
            const minute = (i % 4) * 15;
            return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        });
        const stackedData = dataKwh.map((raw, index) => {
            const hour = Math.floor(index / 4); // Convert 15-min index to hour
            const supplement = this.getSupplement(hour, date);
            return { index, hour, raw, supplement, total: raw + supplement };
        });
        const stackKeys = ["raw", "supplement"];
        const stackGen = d3.stack().keys(stackKeys);
        const series = stackGen(stackedData);
        const minY = d3.min(stackedData, d => Math.min(0, d.raw, d.raw + d.supplement, d.total)) ?? 0;
        const maxY = d3.max(stackedData, d => d.total) ?? 0;
        const minAxisY = 0;
        const maxAxisY = 0.35;
        const axisMin = Math.min(minY, minAxisY);
        const axisMax = Math.max(maxY, maxAxisY);
        // Tooltip setup
        const tooltip = container.append("div")
            .style("position", "absolute")
            .style("background", "#fff")
            .style("border", "1px solid #ccc")
            .style("padding", "6px 10px")
            .style("border-radius", "4px")
            .style("pointer-events", "none")
            .style("font-size", "13px")
            .style("box-shadow", "0 2px 8px rgba(0,0,0,0.15)")
            .style("opacity", 0);
        const now = new Date();
        // Extract hour and minute in CET/CEST (Europe/Madrid) so the highlighted bar aligns with OMIE pricing hours
        const cetParts = new Intl.DateTimeFormat("es-ES", {
            timeZone: "Europe/Madrid",
            hour: "numeric",
            minute: "numeric",
            hour12: false,
        }).formatToParts(now);
        const currentHour = parseInt(cetParts.find(p => p.type === "hour").value, 10);
        const currentMinute = Math.floor(parseInt(cetParts.find(p => p.type === "minute").value, 10) / 15) * 15;
        const currentIndex = currentHour * 4 + Math.floor(parseInt(cetParts.find(p => p.type === "minute").value, 10) / 15);
        const currentTimeLabel = timeLabels[currentIndex];
        const colorMap = {
            raw: this.color1,
            supplement: this.color2
        };
        // --- Legend ---
        const legendData = [
            { color: this.color1, label: lang === 'zh-CN' ? "OMIE价格 (" + eurKwhString + ")" : lang === 'ast-ES' ? "Preciu OMIE (" + eurKwhString + ")" : "Precio OMIE (" + eurKwhString + ")" },
            { color: this.color2, label: lang === 'zh-CN' ? "其他费用 (" + eurKwhString + ")" : "Otros costes (" + eurKwhString + ")" }
        ];
        const legend = svg.append("g").attr("class", "legend");
        if (isMobile) {
            // Vertical legend at the top, left-aligned
            legend.attr("transform", `translate(0,0)`);
            legend.selectAll("g")
                .data(legendData)
                .enter()
                .append("g")
                .attr("transform", (_, i) => `translate(0,${i * 28})`)
                .each(function (d) {
                d3.select(this)
                    .append("rect")
                    .attr("x", 0)
                    .attr("y", 0)
                    .attr("width", 20)
                    .attr("height", 12)
                    .attr("fill", d.color);
                d3.select(this)
                    .append("text")
                    .attr("x", 28)
                    .attr("y", 10)
                    .text(d.label)
                    .attr("font-size", "13px")
                    .attr("fill", "#333");
            });
        }
        else {
            // Horizontal legend at the bottom
            legend.attr("transform", `translate(${margin.left},${height - margin.bottom + 30})`);
            const legendItemWidth = width * 0.33;
            legend.selectAll("g")
                .data(legendData)
                .enter()
                .append("g")
                .attr("transform", (_, i) => `translate(${i * legendItemWidth},0)`)
                .each(function (d) {
                d3.select(this)
                    .append("rect")
                    .attr("x", 0)
                    .attr("y", 5)
                    .attr("width", 20)
                    .attr("height", 12)
                    .attr("fill", d.color);
                d3.select(this)
                    .append("text")
                    .attr("x", 28)
                    .attr("y", 15)
                    .text(d.label)
                    .attr("font-size", "13px")
                    .attr("fill", "#333");
            });
        }
        // --- Draw bars ---
        const feastDays = this.feastDays;
        if (isMobile) {
            // Invert axes: X = value, Y = time
            const x = d3.scaleLinear()
                .domain([axisMin, axisMax])
                .nice()
                .range([margin.left, width - margin.right]);
            // Make bars thicker in mobile by reducing the padding
            const y = d3.scaleBand()
                .domain(timeLabels)
                .range([margin.top + 20, height - margin.bottom])
                .padding(0.02); // Very thin padding for 96 bars
            svg.append("g")
                .selectAll("g")
                .data(series)
                .enter()
                .append("g")
                .attr("fill", d => colorMap[d.key])
                .selectAll("rect")
                .data(d => d.map((v, i) => ({ ...v, key: d.key, index: i })))
                .enter()
                .append("rect")
                .attr("y", (d, i) => y(timeLabels[i]))
                .attr("x", d => x(Math.min(d[0], d[1]))) // Use minimum value for x position
                .attr("height", y.bandwidth())
                .attr("width", d => Math.abs(x(d[1]) - x(d[0])))
                .attr("opacity", d => timeLabels[d.index] === currentTimeLabel ? 0.8 : 1)
                .on("mouseover", function (event, d) {
                d3.select(this).attr("fill", "#f8f091");
                const hour = stackedData[d.index].hour;
                const day = date.getDay();
                let period = lang === 'zh-CN' ? "低谷段" : "Valle";
                let isFeastDay = feastDays.includes(date.toISOString().slice(5, 10));
                if (day === 0 || day === 6 || isFeastDay) {
                    if (lang === 'zh-CN') {
                        period = '低谷段';
                    }
                    else {
                        period = isFeastDay ? "Valle – Festivo" : "Valle";
                    }
                }
                else if ((hour >= 10 && hour < 14) || (hour >= 18 && hour < 22)) {
                    period = lang === 'zh-CN' ? "高峰段" : "Punta";
                }
                else if ((hour >= 8 && hour < 10) || (hour >= 14 && hour < 18) || (hour >= 22 && hour < 24)) {
                    period = lang === 'zh-CN' ? "平原" : lang === 'ast-ES' ? "Llanu" : "Llano";
                }
                let html = `<strong>${timeLabels[d.index]} (${period})</strong><br/>`;
                if (d.key === "raw") {
                    html += `<strong>${lang === 'zh-CN' ? "OMIE价格:" : lang === 'ast-ES' ? "Preciu OMIE:" : "Precio OMIE:"}</strong> ${(stackedData[d.index].raw).toFixed(6)} ${eurKwhString}`;
                }
                else if (d.key === "supplement") {
                    html += `<strong>${lang === 'zh-CN' ? "其他费用:" : "Otros costes:"}</strong> ${(stackedData[d.index].supplement).toFixed(6)} ${eurKwhString}`;
                }
                html += `<br/><strong>${lang === 'zh-CN' ? "总计:" : "Total:"}</strong> ${(stackedData[d.index].total).toFixed(6)} ${eurKwhString}`;
                tooltip
                    .style("opacity", 1)
                    .html(html);
            })
                .on("mousemove", function (event) {
                const [mouseX, mouseY] = d3.pointer(event, container.node());
                tooltip
                    .style("left", (mouseX - 10) + "px")
                    .style("top", (mouseY + 40) + "px");
            })
                .on("mouseleave", function (event, d) {
                d3.select(this).attr("fill", colorMap[d.key]);
                tooltip.style("opacity", 0);
            })
                .each(function (d) {
                if (timeLabels[d.index] === currentTimeLabel) {
                    function pulse(selection) {
                        selection
                            .transition()
                            .duration(700)
                            .attr("opacity", 0.5)
                            .transition()
                            .duration(700)
                            .attr("opacity", 0.8)
                            .on("end", function () { pulse(selection); });
                    }
                    pulse(d3.select(this));
                }
            });
            // X axis (value)
            svg.append("g")
                .attr("transform", `translate(0,${margin.top + 20})`)
                .call(d3.axisTop(x).ticks(5))
                .call(g => g.append("text")
                .attr("x", width - margin.right)
                .attr("y", -28)
                .attr("fill", "#333")
                .attr("text-anchor", "end")
                .attr("font-weight", "bold")
                .text(eurKwhString));
            // Y axis (time) - show only hourly labels to avoid overcrowding
            const hourlyTicks = timeLabels.filter((_, i) => i % 4 === 0); // Every hour
            svg.append("g")
                .attr("transform", `translate(${margin.left}, 0)`)
                .call(d3.axisLeft(y).tickValues(hourlyTicks).tickSizeOuter(0));
        }
        else {
            // Desktop: original vertical bars
            const x = d3.scaleBand()
                .domain(timeLabels)
                .range([margin.left, width - margin.right])
                .padding(0.1); // Adjusted for more bars
            const y = d3.scaleLinear()
                .domain([axisMin, axisMax])
                .nice()
                .range([height - margin.bottom, margin.top]);
            svg.append("g")
                .selectAll("g")
                .data(series)
                .enter()
                .append("g")
                .attr("fill", d => colorMap[d.key])
                .selectAll("rect")
                .data(d => d.map((v, i) => ({ ...v, key: d.key, index: i })))
                .enter()
                .append("rect")
                .attr("x", (d, i) => x(timeLabels[i]))
                .attr("y", d => y(Math.max(d[0], d[1]))) // Use maximum value for y position
                .attr("height", d => Math.abs(y(d[0]) - y(d[1])))
                .attr("width", x.bandwidth())
                .attr("opacity", d => timeLabels[d.index] === currentTimeLabel ? 0.8 : 1)
                .on("mouseover", function (event, d) {
                d3.select(this).attr("fill", "#f8f091");
                const hour = stackedData[d.index].hour;
                const day = date.getDay();
                let period = lang === 'zh-CN' ? "低谷段" : "Valle";
                let isFeastDay = feastDays.includes(date.toISOString().slice(5, 10));
                if (day === 0 || day === 6 || isFeastDay) {
                    if (lang === 'zh-CN') {
                        period = '低谷段';
                    }
                    else {
                        period = isFeastDay ? "Valle – Festivo" : "Valle";
                    }
                }
                else if ((hour >= 10 && hour < 14) || (hour >= 18 && hour < 22)) {
                    period = lang === 'zh-CN' ? "高峰段" : "Punta";
                }
                else if ((hour >= 8 && hour < 10) || (hour >= 14 && hour < 18) || (hour >= 22 && hour < 24)) {
                    period = lang === 'zh-CN' ? "平原" : lang === 'ast-ES' ? "Llanu" : "Llano";
                }
                let html = `<strong>${timeLabels[d.index]} (${period})</strong><br/>`;
                if (d.key === "raw") {
                    html += `<strong>${lang === 'zh-CN' ? "OMIE价格:" : lang === 'ast-ES' ? "Preciu OMIE:" : "Precio OMIE:"}</strong> ${(stackedData[d.index].raw).toFixed(6)} ${eurKwhString}`;
                }
                else if (d.key === "supplement") {
                    html += `<strong>${lang === 'zh-CN' ? "其他费用:" : "Otros costes:"}</strong> ${(stackedData[d.index].supplement).toFixed(6)} ${eurKwhString}`;
                }
                html += `<br/><strong>${lang === 'zh-CN' ? "总计:" : "Total:"}</strong> ${(stackedData[d.index].total).toFixed(6)} ${eurKwhString}`;
                tooltip
                    .style("opacity", 1)
                    .html(html);
            })
                .on("mousemove", function (event) {
                const [mouseX, mouseY] = d3.pointer(event, container.node());
                tooltip
                    .style("left", (mouseX - 10) + "px")
                    .style("top", (mouseY + 40) + "px");
            })
                .on("mouseleave", function (event, d) {
                d3.select(this).attr("fill", colorMap[d.key]);
                tooltip.style("opacity", 0);
            })
                .each(function (d) {
                if (timeLabels[d.index] === currentTimeLabel) {
                    function pulse(selection) {
                        selection
                            .transition()
                            .duration(700)
                            .attr("opacity", 0.5)
                            .transition()
                            .duration(700)
                            .attr("opacity", 0.8)
                            .on("end", function () { pulse(selection); });
                    }
                    pulse(d3.select(this));
                }
            });
            // X Axis - show only hourly labels to avoid overcrowding
            const hourlyTicks = timeLabels.filter((_, i) => i % 4 === 0); // Every hour
            svg.append("g")
                .attr("transform", `translate(0,${y(0)})`)
                .call(d3.axisBottom(x)
                .tickValues(hourlyTicks))
                .selectAll("text")
                .attr("transform", "rotate(-45)")
                .style("text-anchor", "end");
            // Y Axis with legend
            svg.append("g").attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(y))
                .attr("class", "y-axis")
                .call(g => g.append("text")
                .attr("x", -margin.left + 5)
                .attr("y", margin.top - 10)
                .attr("fill", "#333")
                .attr("text-anchor", "start")
                .attr("font-weight", "bold")
                .text(eurKwhString));
        }
    }
}
exports.D3Charts = D3Charts;
